import {
  Box,
  Typography,
} from '@mui/material';
import {styled} from '@mui/system';

export const Card = styled(Box)(({theme}) => ({
  flexDirection: 'row',
  padding: '16px',
}));

export const CardImgContainer = styled(Box)(({theme}) => ({
  textAlign: 'center',
}));

export const CardImg = styled('img')(({theme}) => ({
  height: 'auto',
  width: '80px',
  marginRight: '16px',
}));

export const TypographyH2 = styled(Typography)(({theme}) => ({
  lineHeight: '2rem',
  fontSize: '1.5rem',
  fontWeight: '700',
  color: theme.palette.text.primary,
}));

export const TypographyBody2 = styled(Typography)(({theme}) => ({
  color: theme.palette.text.secondary,
  fontWeight: '400',
  fontSize: '.875rem',
  lineHeight: '1.25rem',
}));

export const CardDivider = styled('hr')(({theme}) => ({
  marginTop: '12px',
  marginBottom: '12px',
  width: '100%',
  borderStyle: 'none',
  borderBottom: `1px solid ${theme.palette.common.swatch['30']}`,
}));

export const Actions = styled(Box)(({theme}) => ({
  textAlign: 'center',
  flexDirection: 'row',
  paddingTop: '8px',
  display: 'flex',
  gap: '12px',
}));
